import { useMemo, type ReactNode, useEffect } from 'react';
import { AuthContext, type AuthContextProps } from '../contexts/auth.context';

import { useCookies } from 'react-cookie';
import { setTag, addBreadcrumb } from '@/config/sentry.config';

type AuthProviderProps = {
  children: ReactNode;
};

export function AuthProvider({ children }: AuthProviderProps) {
  const [authToken, setToken, removeToken] = useCookies<string>(['x-auth-token']);
  const isAuthenticated = useMemo(() => !!authToken['x-auth-token'], [authToken]);

  // Rastrear mudanças no estado de autenticação
  useEffect(() => {
    setTag('authenticated', String(isAuthenticated));

    addBreadcrumb(
      `Estado de autenticação: ${isAuthenticated ? 'autenticado' : 'não autenticado'}`,
      'auth',
      'info',
      { isAuthenticated }
    );
  }, [isAuthenticated]);

  const token: AuthContextProps['token'] = {
    get: () => authToken['x-auth-token'] ?? '',
    save: (token: string) => {
      addBreadcrumb('Token salvo', 'auth', 'info');
      setToken('x-auth-token', token);
    },
    clean: () => {
      addBreadcrumb('Token removido (logout)', 'auth', 'info');
      removeToken('x-auth-token');
    },
  };

  return <AuthContext value={{ token, isAuthenticated }}>{children}</AuthContext>;
}
